import { createContext, useContext } from "react";

const GlobalNotificationContext = createContext();

const useNotification = () => {
  return useContext(GlobalNotificationContext);
};

export { useNotification, GlobalNotificationContext as default };
